<div
  class="rs-panel-big rs-bg-c2 rs-margin-bottom4-m"
  *ngIf="!isPlacedAtRightSide; else atRightSide"
>
  <div class="rs-flex-row rs-flex-top-small-only rs-flex-middle-medium">
    <div class="rs-flex-column">
      <p data-cy="myBillOdbExplanationIntroTitle">
        {{ 'bills.cover.explanationIntro.' + billExplanationType | translate }}
      </p>
      <a
        (click)="goToExplanationPage()"
        class="rs-btn rs-btn-third"
        data-cy="myBillOdbExplanationIntroLink"
      >
        {{ 'bills.cover.explanationIntro.readMore' | translate }}
        <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"> </i
      ></a>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <img
        class="show-for-medium-up"
        src="{{ 'bills.cover.explanationIntro.image' | translate }}"
        alt=""
        loading="lazy"
        data-cy="myBillOdbExplanationIntroImage"
      />
      <img
        class="show-for-small-only"
        src="{{ 'bills.cover.explanationIntro.smallImage' | translate }}"
        alt=""
        loading="lazy"
      />
    </div>
  </div>
</div>
<ng-template #atRightSide>
  <div class="rs-panel-flex-cell-big rs-bg-c2">
    <div class="rs-flex-row rs-flex-top-small-only rs-flex-middle-medium">
      <div class="rs-flex-column">
        <p data-cy="myBillOdbExplanationIntroTitle">
          {{
            'bills.cover.explanationIntro.' + billExplanationType | translate
          }}
        </p>
        <a
          (click)="goToExplanationPage()"
          class="rs-btn rs-btn-third"
          data-cy="myBillOdbExplanationIntroLink"
        >
          {{ 'bills.cover.explanationIntro.readMore' | translate }}
          <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"> </i
        ></a>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <img
          class="show-for-medium-up"
          src="{{ 'bills.cover.explanationIntro.image' | translate }}"
          alt=""
          loading="lazy"
          data-cy="myBillOdbExplanationIntroImage"
        />
        <img
          class="show-for-small-only"
          src="{{ 'bills.cover.explanationIntro.smallImage' | translate }}"
          alt=""
          loading="lazy"
        />
      </div>
    </div>
  </div>
</ng-template>
